import 'protons';
import './_footer.scss';
import './_footer.twig';

export const name = 'footer';

export const defaults = {};

export function disable() {}

export function enable() {
  const scrollBtn = document.querySelector('.footer__up-btn');
  if (scrollBtn) {
    scrollBtn.addEventListener('click', (event) => {
      event.preventDefault();
      document.documentElement.scrollTop = 0;
    });
  }
}

export default enable;
